import config from './config.json';

type ConfigKey = keyof typeof config;

const hostname = window.location.hostname;

export const environment: ConfigKey = (() => {
  if (hostname.includes('localhost')) {
    return 'development.local';
  }

  if (hostname.includes('transport-dev')) {
    return 'development.deploy';
  }

  if (hostname.includes('transport-stg')) {
    return 'stage';
  }

  return 'production';
})();

export const CONFIG = config[environment];
